import React from 'react';
import { Scale, Download, Calendar, FileText, User } from 'lucide-react';

const AuthorityDecisionsSection = ({ caseData, portalType = 'individual' }) => {
  const primaryColor = portalType === 'business' ? '#1E3A8A' : '#10B981';
  const secondaryColor = portalType === 'business' ? '#2563EB' : '#34D399';
  const lightBg = portalType === 'business' ? 'from-blue-50 to-white' : 'from-emerald-50 to-white';
  const lightBorder = portalType === 'business' ? 'border-[#1E3A8A]/30' : 'border-[#10B981]/30';
  
  return (
    <div className="bg-white rounded-xl shadow-sm border-2 border-gray-200 p-8">
      <div className="flex items-center gap-3 mb-6">
        <div 
          className="w-12 h-12 rounded-xl flex items-center justify-center"
          style={{ background: `linear-gradient(to bottom right, ${primaryColor}, ${secondaryColor})` }}
        >
          <Scale className="w-7 h-7 text-white" strokeWidth={2.5} />
        </div>
        <h2 className="text-3xl font-black" style={{ color: primaryColor }}>القرارات الصادرة من الجهة المختصة</h2>
      </div>

      {caseData.authorityDecisions && caseData.authorityDecisions.length > 0 ? (
        <div className="space-y-6">
          {caseData.authorityDecisions.map((decision) => (
            <div 
              key={decision.id}
              className={`border-2 ${lightBorder} rounded-xl p-6 transition-all hover:shadow-lg bg-gradient-to-br ${lightBg}`}
              style={{ borderColor: `${primaryColor}30` }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = primaryColor}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = `${primaryColor}30`}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div 
                    className="w-12 h-12 rounded-xl flex items-center justify-center"
                    style={{ background: `linear-gradient(to bottom right, ${primaryColor}, ${secondaryColor})` }}
                  >
                    <Scale className="w-6 h-6 text-white" strokeWidth={2.5} />
                  </div>
                  <div>
                    <h3 className="text-xl font-black text-gray-900">{decision.title}</h3>
                    <div className="flex items-center gap-2 mt-1">
                      <span 
                        className="px-3 py-1 rounded-full text-xs font-bold"
                        style={{ 
                          backgroundColor: portalType === 'business' ? '#DBEAFE' : '#D1FAE5',
                          color: portalType === 'business' ? '#1E40AF' : '#065F46'
                        }}
                      >
                        {decision.type}
                      </span>
                      <span className="text-sm text-gray-500 font-semibold">• {decision.decisionNumber}</span>
                    </div>
                  </div>
                </div>
                {decision.canDownload && (
                  <button className="px-4 py-2 bg-[#C8A870] hover:bg-[#1E3A8A] text-white rounded-lg transition-colors flex items-center gap-2 font-bold">
                    <Download className="w-4 h-4" />
                    <span>تحميل</span>
                  </button>
                )}
              </div>

              <div 
                className="bg-white rounded-lg p-4 mb-4 border-2"
                style={{ borderColor: portalType === 'business' ? '#DBEAFE' : '#D1FAE5' }}
              >
                <div className="flex items-center gap-2 mb-2" style={{ color: primaryColor }}>
                  <FileText className="w-5 h-5" />
                  <span className="font-bold text-sm">ملخص القرار</span>
                </div>
                <p className="text-gray-800 leading-relaxed font-semibold">{decision.summary}</p>
              </div>

              <div 
                className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t"
                style={{ borderColor: portalType === 'business' ? '#DBEAFE' : '#D1FAE5' }}
              >
                <div className="flex items-center gap-3 text-gray-700">
                  <User className="w-5 h-5" style={{ color: primaryColor }} />
                  <div>
                    <div className="text-xs text-gray-500 font-semibold">صادر من</div>
                    <div className="font-bold">{decision.issuedBy}</div>
                  </div>
                </div>
                
                <div className="flex items-center gap-3 text-gray-700">
                  <Calendar className="w-5 h-5" style={{ color: primaryColor }} />
                  <div>
                    <div className="text-xs text-gray-500 font-semibold">تاريخ القرار</div>
                    <div className="font-bold">{decision.date}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 text-gray-500">
          <Scale className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <p className="text-lg font-bold">لا توجد قرارات صادرة</p>
        </div>
      )}
    </div>
  );
};

export default AuthorityDecisionsSection;